import { transferOrderIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";
import { TransferFileSchema_ } from "./transfer-types";

export const addTransferFile = {
  name: "addTransferFile" as const,
  input: z.object({
    transferId: transferOrderIdFormat.schema,
    title: z.string(),
  }),
  output: z.object({ file: TransferFileSchema_ }),
};
